module.exports = __webpack_public_path__ + "static/media/bluebells1.7da3ffac.png";